import { NgModule } from '@angular/core';
import { FilterLeistungStatusPipe } from './filter-leistung-status/filter-leistung-status';
import { FilterLeistungKundePipe } from './filter-leistung-kunde/filter-leistung-kunde';
import { FilterLeistungSearchPipe } from './filter-leistung-search/filter-leistung-search';
import { FilterExpenseStatusPipe } from './filter-expense-status/filter-expense-status';
@NgModule({
	declarations: [FilterLeistungStatusPipe,
    FilterLeistungKundePipe,
    FilterLeistungSearchPipe,
    FilterExpenseStatusPipe],
	imports: [],
	exports: [FilterLeistungStatusPipe,
    FilterLeistungKundePipe,
    FilterLeistungSearchPipe,
    FilterExpenseStatusPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts